<template>
  <div class="menuBody">
    <DailyChargeTree @DailyChargeTree="getMsgFormSon" />
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
           <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="应收列表" name="first">应收列表</el-tab-pane>
                <el-tab-pane label="其他收费列表" name="second">其他收费列表</el-tab-pane>
                <el-tab-pane label="收款情况查询" name="third">收款情况查询</el-tab-pane>
              </el-tabs>
            </div>
            <div style="float:left;margin-right:10px;">
                <el-radio v-model="radio" label="1">到期未收(欠收)</el-radio>
            </div>
            <div style="float:left;margin-right:10px;">
                <el-radio v-model="radio" label="2">未到期未收</el-radio>
            </div>
            <div style="float:left;margin-right:10px;">
                <el-radio v-model="radio" label="3">到期已收</el-radio>
            </div>
            <div style="float:left;margin-right:10px;">
                <el-radio v-model="radio" label="4">未到期已收(预收)</el-radio>
            </div>
            <div style="float:left;margin-right:10px;margin-top:-5px">
                 <el-date-picker
                  v-model="DateTime"
                  type="month"
                  size="small"
                  placeholder="选择日期">
                </el-date-picker>
            </div>
            <div style="float:left;margin-right:10px;margin-top:-5px">
              <el-cascader
              :options="ChargeItem"
              :props="props"
              size="small"
              collapse-tags
              clearable></el-cascader>
            </div>
            <div style="float:left;margin-right:10px;margin-top:-5px;">
               <el-button type="primary" size="small" plain   @click="Inquire()" v-Jurisdiction="'expense:web:cp:dailyCp:getbillsbystu'" >查询</el-button>
            </div>
             <el-table  :data="tableData" v-loading="loading" tooltip-effect="light"   style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="55"></el-table-column>
    <el-table-column show-overflow-tooltip prop="status" label="收" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeNameone" label="项目"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjCny" label="应收年月"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjJe" label="应收金额" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkrqDate" label="收款日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收款方式"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payuserName" label="收款人"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceGrnno" label="票据簿编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceNo" label="发票号码"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjTksm" label="账单备注" ></el-table-column>
    <el-table-column fixed="right" label="详情" >
    <template slot-scope="scope">
        <el-button @click="particulars(scope.row)" type="primary" v-Jurisdiction="'expense:web:cp:dailyCp:fromBles'" v-show="scope.row.invoiceGrnno != null && scope.row.invoiceNo != null" icon="el-icon-s-order" circle size="small" title="收款详情"></el-button>
        <el-button @click="examine(scope.row)" type="primary" v-show="scope.row.ext3 != null" icon="el-icon-view" v-Jurisdiction="'expense:web:cp:dailyCp:printArea'"   circle size="small" title="查看"></el-button>
    </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
// import DailyChargeDialog from "../common/DailyChargeDialog";
import DailyChargeTree from "../common/DailyChargeTree.vue";

export default {
  name: "ChargSituation",
     watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/charge/bills/dailyIndex"){
       this.activeName = "first"
       }else if(`${newVal}` == "/cha/ElseCharge"){
        this.activeName = "second"
       }else if(`${newVal}` == "/cha/ChargSituation"){
        this.activeName = "third"
       }
     }
  },
  components: {DailyChargeTree},
  data() {
    return {
       activeName: 'third',
      loading:false,
      DateTime:"",
      radio:"0",
      ChargeItem:[],
      props:{},
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        CourseCode:"",
      tableData: [],
      options: [],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:"",
      customerId:"",
      roomId:"",
      roomName:"",
      customerName:"",
      roomProperty:"",
      buildArea:"",
      projectId:"",
    }
  },

  methods: {
         handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'DailyCharge'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'ElseCharge'})
        }else if(this.activeName == "third"){
          this.activeName = "third"
          this.$router.push({name: 'ChargSituation'})
        }
      },
    Inquire(){
      // 查询
    },
    examine(val){
      window.open(val.ext3, '_blank')
    },
    particulars(val){
      let obj = {
        "invoiceDm":val.invoiceGrnno,
        "invoiceHm":val.invoiceNo,
      }
      this.$http.get("/charge/web/chargeBills/fromBles?invoiceDm="+val.invoiceGrnno+"&"+"invoiceHm"+"="+val.invoiceNo).then((res)=>{
        // console.log(res.data.data)
        let data = res.data.data
        // console.log(data)

      })
    },
    getMsgFormSon(data){
      if(data.roomId){
         this.loading = true
          this.roomId = data.roomId
          this.roomName = data.roomName
          this.customerId = data.customerId
          this.customerName = data.customerName
          this.roomProperty = data.roomProperty
          this.buildArea = data.buildArea
          this.ShareList()
        }else if(data.orgId != null){
          this.projectId = data.id
        }
      this.AllData = data
    },
     handleSizeChange(val) {
       this.loading = true
        // console.log(`每页 ${val} 条`);
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.loading = true
        // console.log(`当前页: ${val}`);
        this.currentPage = val
        this.ShareList()
    },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "customerId":this.customerId,// 业主ID
            "projectId":this.projectId,
      }
      // console.log(PageSize)
        this.$http.post(this.$requestUrl.POST_CHERGE_BILLS,PageSize).then((res) => {
          let data = res.data;
          let arr = []
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.weight()
            // this.tableData = arr
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
        weight(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
            // console.log(res.data.data,"tvt")
            for(let val of res.data.data){
                this.circulation(val)
            }
        })
    },
    circulation(obj){
        let arr = []
        for(let val of this.tableData){
            if(val.feeitemCode == obj.feeCode){
                val.feeNameone = obj.feeName
            }
             if(val.ext4 == "3" || val.ext4 == "4"){
              // console.log(val,"ext4")
              val.status == "已收"
              }
            arr.push(val)
        }
        // this.tableData = arr
    },

    NodeData(data){
        // console.log(data,"data")
        this.mangroupId = data.value
        this.mangrouplab = data.label
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
</style>